/* ================================================
   PUPPY PLACE - THEME.JS
   ================================================ */

document.addEventListener("DOMContentLoaded", function () {
  /* ================================================
     HAMBURGER MENU
     ================================================ */
  const hamburger = document.querySelector(".hamburger");
  const mobileMenu = document.querySelector(".mobile-menu");

  if (hamburger && mobileMenu) {
    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("active");
      mobileMenu.classList.toggle("active");
    });

    document.addEventListener("click", (e) => {
      if (!hamburger.contains(e.target) && !mobileMenu.contains(e.target)) {
        hamburger.classList.remove("active");
        mobileMenu.classList.remove("active");
      }
    });
  }

  /* ================================================
     HAMBURGER SUBMENÚS (acordeón)
     ================================================ */
  document.querySelectorAll(".mobile-nav-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const navItem = btn.closest(".mobile-nav-item");
      const submenu = navItem.querySelector(".mobile-submenu");
      const isOpen = btn.classList.contains("open");
      btn.classList.toggle("open", !isOpen);
      btn.setAttribute("aria-expanded", !isOpen);
      submenu.classList.toggle("open", !isOpen);
    });
  });

  /* ================================================
     SEARCH BAR MOBILE
     ================================================ */
  const searchToggle = document.querySelector(".search-toggle");
  const searchBar = document.querySelector(".search-bar");

  if (searchToggle && searchBar) {
    searchToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      searchBar.classList.toggle("active");
    });

    document.addEventListener("click", (e) => {
      if (!searchBar.contains(e.target)) {
        searchBar.classList.remove("active");
      }
    });
  }

  /* ================================================
     CART DRAWER
     ================================================ */
  const cartDrawer = document.getElementById("cartDrawer");
  const cartDrawerClose = document.querySelector(".cart-drawer-close");
  const cartDrawerOverlay = document.querySelector(".cart-drawer-overlay");
  const continueShoppingBtns = document.querySelectorAll(
    ".btn-continue-shopping, .btn-continue-shopping-footer",
  );

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add("active");
      document.body.style.overflow = "hidden";
      loadCartItems();
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove("active");
      document.body.style.overflow = "";
    }
  }

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener("click", closeCartDrawer);
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener("click", closeCartDrawer);
  }

  continueShoppingBtns.forEach((btn) => {
    btn.addEventListener("click", closeCartDrawer);
  });

  /* ================================================
     LOAD CART ITEMS
     ================================================ */
  function loadCartItems() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const itemsContainer = document.querySelector(".cart-drawer-items");
        const emptyState = document.querySelector(".cart-drawer-empty");
        const footer = document.querySelector(".cart-drawer-footer");
        const subtotalPrice = document.querySelector(".cart-subtotal-price");

        if (cart.item_count === 0) {
          itemsContainer.style.display = "none";
          footer.style.display = "none";
          emptyState.style.display = "flex";
        } else {
          itemsContainer.style.display = "block";
          footer.style.display = "block";
          emptyState.style.display = "none";

          itemsContainer.innerHTML = cart.items
            .map(
              (item) => `
            <div class="cart-item" data-key="${item.key}">
              <div class="cart-item-image">
                <img src="${item.image}" alt="${item.title}" loading="lazy">
              </div>
              <div class="cart-item-details">
                <div class="cart-item-title">
                  <a href="${item.url}">${item.product_title}</a>
                </div>
                <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
                <div class="cart-item-quantity">
                  <div class="quantity-controls">
                    <button class="quantity-btn quantity-minus" data-key="${item.key}" ${item.quantity <= 1 ? "disabled" : ""}>−</button>
                    <input type="number" class="quantity-input" value="${item.quantity}" min="1" readonly>
                    <button class="quantity-btn quantity-plus" data-key="${item.key}">+</button>
                  </div>
                  <button class="cart-item-remove" data-key="${item.key}">Eliminar</button>
                </div>
              </div>
            </div>
          `,
            )
            .join("");

          subtotalPrice.textContent = formatMoney(cart.total_price);

          // Attach event listeners
          attachCartItemListeners();
        }

        updateCartBadge();
      })
      .catch((error) => console.error("Error loading cart:", error));
  }

  /* ================================================
     CART ITEM LISTENERS
     ================================================ */
  function attachCartItemListeners() {
    // Quantity plus
    document.querySelectorAll(".quantity-plus").forEach((btn) => {
      btn.addEventListener("click", function () {
        const key = this.dataset.key;
        const input = this.parentElement.querySelector(".quantity-input");
        const newQty = parseInt(input.value) + 1;
        updateCartItem(key, newQty);
      });
    });

    // Quantity minus
    document.querySelectorAll(".quantity-minus").forEach((btn) => {
      btn.addEventListener("click", function () {
        const key = this.dataset.key;
        const input = this.parentElement.querySelector(".quantity-input");
        const newQty = parseInt(input.value) - 1;
        if (newQty >= 1) {
          updateCartItem(key, newQty);
        }
      });
    });

    // Remove item
    document.querySelectorAll(".cart-item-remove").forEach((btn) => {
      btn.addEventListener("click", function () {
        const key = this.dataset.key;
        updateCartItem(key, 0);
      });
    });
  }

  /* ================================================
     UPDATE CART ITEM
     ================================================ */
  function updateCartItem(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        loadCartItems();
      })
      .catch((error) => console.error("Error updating cart:", error));
  }

  /* ================================================
     CART BADGE UPDATE
     ================================================ */
  function updateCartBadge() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const badges = document.querySelectorAll(".header-icon .badge");
        badges.forEach((badge) => {
          if (
            badge.closest('.header-icon[href="/cart"]') ||
            badge.closest('a[href*="cart"]')
          ) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? "flex" : "none";
          }
        });
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  // Actualizar badge al cargar página
  updateCartBadge();

  /* ================================================
     FORMAT MONEY
     ================================================ */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `S/. ${amount}`;
  }

  /* ================================================
     ADD TO CART BUTTONS (event delegation for dynamic content)
     ================================================ */
  document.addEventListener("click", async function (e) {
    const button = e.target.closest(".btn-add-cart, .btn-add-to-cart");
    if (!button) return;

    e.preventDefault();

    const variantId = button.dataset.productId || button.dataset.variantId;

    if (!variantId) {
      console.error("No variant ID found");
      return;
    }

    // Feedback visual inmediato
    const originalText = button.textContent;
    const originalBg = button.style.backgroundColor;

    button.textContent = "✓ Añadido";
    button.style.backgroundColor = "#4CAF50";
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(document.getElementById('productQty')?.value) || 1,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al añadir al carrito");
      }

      const data = await response.json();

      // Resetear selector de cantidad a 1
      const qtyInput = document.getElementById('productQty');
      if (qtyInput) qtyInput.value = 1;

      // Abrir cart drawer automáticamente y cargar cross-sell
      openCartDrawer();
      loadCrossSellProducts(data.product_id);

      // Restaurar botón después de 1.5 segundos
      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = originalBg;
        button.disabled = false;
      }, 1500);
    } catch (error) {
      console.error("Error:", error);

      button.textContent = "✗ Error";
      button.style.backgroundColor = "#f44336";

      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = originalBg;
        button.disabled = false;
      }, 2000);
    }
  });

  /* ================================================
     CROSS-SELL PRODUCTS
     ================================================ */
  function loadCrossSellProducts(productId) {
    if (!productId) return;
    const crosssell = document.getElementById("cartCrosssell");
    const container = document.getElementById("cartCrosssellItems");
    if (!crosssell || !container) return;

    fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
      .then((r) => r.json())
      .then((data) => {
        const products = data.products;
        if (!products || products.length === 0) {
          crosssell.style.display = "none";
          return;
        }
        crosssell.style.display = "block";
        container.innerHTML = products.map((p) => `
          <div class="crosssell-card">
            <a href="${p.url}">
              <img src="${p.featured_image}" alt="${p.title}" loading="lazy">
            </a>
            <div class="crosssell-card-info">
              <div class="crosssell-card-title">${p.title}</div>
              <div class="crosssell-card-price">${formatMoney(p.price)}</div>
              <button class="crosssell-card-btn btn-add-cart" data-product-id="${p.variants[0].id}">
                Añadir
              </button>
            </div>
          </div>
        `).join("");
      })
      .catch(() => { crosssell.style.display = "none"; });
  }

  /* ================================================
     SMOOTH SCROLL
     ================================================ */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (href !== "#" && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    });
  });
});
